import { Injectable } from '@angular/core';
import { OptimizelyService } from '~shared/services/optimizely.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AddToCardConfig } from '~shared/modules/product-card/models/add-to-card-config.model';

@Injectable({
  providedIn: 'root',
})
export class PlpAddToCartService {
  constructor(private optimizelyService: OptimizelyService) {}
  public getPlpsAddToCartVariant(): Observable<AddToCardConfig> {
    return this.optimizelyService.getExperimentVariant('plps_add_to_cart').pipe(
      map((variant: string) => ({
        shouldShowAddToCart: variant === 'add_to_cart_button' || variant === 'add_to_cart_without_moq',
        shouldHideMOQ: variant === 'add_to_cart_without_moq',
      }))
    );
  }
}
